<!DOCTYPE html>
<div class="countdown-timer">
  <span class="time">
    <span class="text">
      {{ isBannerTimerExpired && waitTitle
      ? waitTitle + ' '
      : ''
      }}
      {{ displayString }}
    </span>
    @if (imageExists && waitTitle !=null) {
      <img src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/game%2FgameSlider%2FRectangle%202416.svg?alt=media&token=82564c3a-0f8d-4bdd-83b4-ac22f7afa9b8" class="corner" alt="corner-rectangle"/>
    }
  </span>
  <img src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/game%2FgameSlider%2FBooster%20Icon%2002%201.svg?alt=media&token=ab4ce3f2-c70b-45bc-83ca-088a4fe40c85" class="clock" alt="clock"/>
</div>
